<script lang="ts">
    import Subject from "../../../application/SyllabusManager/models/Subject.ts";
    import {_} from "svelte-i18n";
    import {writable} from "svelte/store";

    export let subjectData: Subject;
    export let languages;
    export let hasDescription;
    $: data = writable(subjectData);

    $: {
        if($languages === 'hu'){
            if($data.description_hu !== null && $data.description_hu !== ""){
                hasDescription = true;
            }
        }
        if($languages==="en"){
            if($data.description_en !== null && $data.description_en !== ""){
                hasDescription = true;
            }
        }
    }
</script>

<div class:is-hidden={!hasDescription}>
    <div class="divider">{$_('subjectCard.description')}</div>
    <strong>{$_('subjectCard.description')}:</strong>
    <br>
    <br>
    {#if $languages === 'hu'}
        <p>{$data.description_hu}</p>
    {/if}
    {#if $languages === 'en'}
        <p>{$data.description_en}</p>
    {/if}
</div>